import React from 'react';
import { useParams } from 'react-router-dom';
import { SandboxProvider } from '../../../contexts/SandboxContext';
import { AdvDeviceReplacementPage } from '../../management/AdvDeviceReplacement';
import { CatalogueProvider } from '../../../services/catalogue/CatalogueService';
import { RoleType } from '../../../services/authentication/hooks/user';

export const SandboxAdvDeviceReplacement: React.FC = () => {
  const { partnerId, companyId } = useParams<{ partnerId: string; companyId: string }>();

  if (!partnerId || !companyId) {
    return <div className="p-8 text-red-500">Missing partnerId or companyId in URL.</div>;
  }

  return (
    <SandboxProvider isSandboxMode={true}>
      <CatalogueProvider 
        configuration={{ 
          for: RoleType.Company, 
          as: RoleType.Admin,
          partnerId, 
          companyId 
        }}
      >
        <AdvDeviceReplacementPage />
      </CatalogueProvider>
    </SandboxProvider>
  );
};
